import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tick-circle-icon",
  "use": "icon-tick-circle-icon-usage",
  "viewBox": "0 0 70 70",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70 70\" fill=\"none\" id=\"icon-tick-circle-icon\">\n  <path d=\"M24.1298 36.1484L31.984 44.6275L49.4006 27.0442\" stroke=\"currentColor\" stroke-width=\"2.04167\" stroke-linecap=\"round\" />\n  <circle cx=\"35.5828\" cy=\"35.583\" r=\"24.5\" stroke=\"currentColor\" stroke-width=\"2.04167\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol